export const APP_TOKEN_KEY = 'PORFIREVICH_USER_TOKEN_KEY';
